import type { AllowedWidth } from '@/app/components/media/app-image';
import type { SizesString } from '@/app/components/media/app-image/shared/image-size-types';

export const COMPARE_GALLERY_IMAGE_PARAMS = { ar: '16-9' } as const;

export const COMPARE_GALLERY_INLINE_SIZES =
  '(min-width: 1024px) 384px, calc((100vw - 32px) / 2)' satisfies SizesString;

export const COMPARE_GALLERY_INLINE_MOBILE_WIDTHS = [
  384, 640, 750, 828, 1080,
] as const satisfies readonly AllowedWidth[];

export const COMPARE_GALLERY_INLINE_DESKTOP_WIDTHS = [
  384, 640, 750, 828,
] as const satisfies readonly AllowedWidth[];

export const COMPARE_GALLERY_MODAL_SIZES =
  '(min-width: 1280px) 1280px, 100vw' satisfies SizesString;

export const COMPARE_GALLERY_MODAL_MOBILE_WIDTHS = [
  640, 750, 828, 1080, 1280, 1440, 1680, 1920,
] as const satisfies readonly AllowedWidth[];

export const COMPARE_GALLERY_MODAL_DESKTOP_WIDTHS = [
  1280, 1440, 1680, 1920,
] as const satisfies readonly AllowedWidth[];
